import { Component, Input, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { BulkOrder } from '@app/core/models/bulk-upload.model';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
  selector: 'ecp-bulk-order-list',
  templateUrl: './bulk-order-list.component.html',
  styleUrls: ['./bulk-order-list.component.scss'],
})
export class BulkOrderListComponent implements OnInit {
  bulkOrderList: any = new MatTableDataSource(null);
  @Input() orderData: any;
  @Output() orderDetails = new EventEmitter<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  bulkOrderColumns: string[] = ['filename', 'itemCount', 'uploadedOn', 'uploadStatus', 'action'];
  constructor() {}

  ngOnInit(): void {}
  ngOnChanges() {
    if (this.orderData) {
      this.bulkOrderList = new MatTableDataSource(this.orderData);
      this.bulkOrderList.paginator = this.paginator;
      this.bulkOrderList.sort = this.sort;
      console.log(this.bulkOrderList, this.sort);
    }
  }
  sortOrder(sort: Sort) {
    const data = this.orderData.slice();
    if (!sort.active || sort.direction === '') {
      this.orderData = data;
      return;
    }

    this.orderData = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      switch (sort.active) {
        case 'filename':
          return compare(a.filename, b.filename, isAsc);
        case 'uploadedOn':
          return compare(a.uploadedOn, b.uploadedOn, isAsc);
        case 'itemCount':
          return compare(a.itemCount, b.itemCount, isAsc);
        case 'uploadStatus':
          return compare(a.uploadStatus, b.uploadStatus, isAsc);
        default:
          return 0;
      }
    });
  }
  viewDetails(data: any) {
    this.orderDetails.emit(data.bulkOrderId);
  }
  formatLocalTime(val: string) {
    let responseDate = new Date(val);
    return new Date(responseDate.toLocaleString());
  }
}

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}
